import BaseModelInstance from './base.model'
import { UserMessage as ModelDefinition } from './model-definitions'

class UserMessage extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default UserMessage
